// src/components/icons/SwiperArrowRight.jsx
import React from 'react';

const SwiperArrowRight = (props) => (
  <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="23.334" width="33" height="33" rx="16.5" transform="rotate(45 23.334 0)" fill="#E4ECEF"/>
    <path d="M16.97 23.3344H29.6979M29.6979 23.3344L24.6068 18.2433M29.6979 23.3344L24.6068 28.4256" stroke="black" strokeWidth="1.08" strokeLinecap="round"/>
  </svg>
);

export default SwiperArrowRight;